import React, { useEffect } from 'react';
import BasicLayout from '../layouts/BasicLayout';
//import { login } from '@/api/sessionAPI';
//import { useDispatch } from 'react-redux';
//import { setSession } from '@/components/sessionSlice';
import { useNavigate } from 'react-router-dom';
import { sessionSelector } from '@/store/selector';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';

const LoginView = () => {
  const session = sessionSelector();
  //const dispatch = useDispatch();
  //const [errors, setErrors] = useState({ alias: null, password: null });
  //const [failed, setFailed] = useState(false);
  const navigate = useNavigate();
  /* const [credentials, setCredentials] = useState({
    alias: '',
    password: '',
  });
  const [loading, setLoading] = useState(false); */

  /*  const onSubmit = () => {
    setLoading(true);
    setFailed(false);
    login(credentials)
      .then((res) => {
        dispatch(setSession(res.data));
      })
      .catch(onError);
  };

  const onError = () => {
    setLoading(false);
    setFailed(true);
  }; */

  //const { alias, password } = credentials;

  /* const onChange = (_event, { id, value }) => {
    setErrors({ ...errors, [id]: null });
    setCredentials({ ...credentials, [id]: value.trim() });
  }; */

  useEffect(() => {
    if (session?.token) {
      return navigate('/reservas');
    }
  }, [session]);

  return (
    <BasicLayout>
      <Stack direction="horizontal" gap={2}>
        <Button as="a" variant="primary">
          Button as link
        </Button>
        <Button as="a" variant="success">
          Button as link
        </Button>
      </Stack>
    </BasicLayout>
  );
};

export default React.memo(LoginView);
